import { useEffect, useState } from 'react';
import type { MenuItem } from 'types/capi/plp';

import FilterOptionsListItem from './FilterOptionsListItem';
import Search from './Search';

type Props = {
  isDropdown?: boolean;
  items: MenuItem[];
  menuId: string;
  onOptionSelect: ({
    filterName,
    filterValue
  }: {
    filterName: string;
    filterValue: string;
  }) => void;
  title: string;
  truncateItems?: boolean;
};

const matchesFilter = (itemText: string, filterValue: string) => {
  return itemText.toLowerCase().includes(filterValue.toLowerCase());
};

const FilterOptionsList = ({
  menuId,
  items,
  isDropdown,
  onOptionSelect = () => {},
  title,
  truncateItems
}: Props) => {
  const [showTruncatedItems, setShowTruncatedItems] = useState(!truncateItems);
  const [searchedItems, setSearchedItems] = useState(items);
  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {
    const filteredItems = items?.filter(({ text }) => {
      return matchesFilter(text, searchQuery);
    });
    setSearchedItems(filteredItems);
  }, [items, searchQuery]);

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setShowTruncatedItems(true);

    if (e.target.value === '') setShowTruncatedItems(!truncateItems);

    setSearchQuery(e.target.value);
  };

  const itemsToShow = showTruncatedItems
    ? searchedItems
    : searchedItems.slice(0, 7);

  const shouldShowSearch = items.length > 7;

  return (
    <>
      {shouldShowSearch && (
        <div
          className={`flex items-center justify-center px-4 pb-4 ${
            isDropdown && 'bg-concrete pt-4 md:px-4'
          }`}
        >
          <Search value={searchQuery} onChange={handleSearchChange} />
        </div>
      )}
      {itemsToShow?.map((item, index) => (
        <FilterOptionsListItem
          menuId={menuId}
          isDropdown={isDropdown}
          item={item}
          key={`${item.path}-${index}`}
          onSelect={(value) =>
            onOptionSelect({ filterName: title, filterValue: value })
          }
        />
      ))}
      {truncateItems && !searchQuery && items.length > 7 && (
        <button
          onClick={() => setShowTruncatedItems(!showTruncatedItems)}
          className="px-4 pb-4 text-sm font-bold md:px-8"
        >
          {!showTruncatedItems
            ? `View all ${title?.toLowerCase()} (A-Z)`
            : 'View less'}
        </button>
      )}
    </>
  );
};

export default FilterOptionsList;
